import { Component, Inject, ViewEncapsulation, ViewChild, ElementRef, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18N } from 'ess-plugin-base';

export interface FolderData {
    path: string;
    name: string;
    guid: string;
    title: string,
    action: FileAction;
}

export enum FileAction {
    NOOP = 'noop',
    RENAME_FILE = 'rename_file',
    RENAME_FOLDER = 'rename_folder',
    DELETE_FILE = 'delete_file',
    DELETE_FOLDER = 'delete_folder',
    NEW_FOLDER = 'new_folder',
}

@Component({
    selector: 'file-dialog',
    templateUrl: './file.dialog.html',
    styleUrls: ['./file.dialog.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FileDialog implements OnChanges, OnInit {

    @ViewChild('input', {static: true})
    input: ElementRef;

    defaultTitle: string;
    
    canRename: boolean;
    canDelete: boolean;

    // newFolder: string = '';

    constructor(public dialogRef: MatDialogRef<FileDialog>, public i18n: I18N, 
        @Inject(MAT_DIALOG_DATA) public data: FolderData) {

        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    ngOnInit() {
        this.switchTitle();
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.switchTitle();
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    switchTitle() {
        this.canDelete = this.data.action == FileAction.DELETE_FILE || this.data.action == FileAction.DELETE_FOLDER;

        this.canRename = this.data.action != FileAction.DELETE_FILE && this.data.action != FileAction.DELETE_FOLDER;

        if (this.data && this.data.action) {
            switch(this.data.action) {
                case FileAction.NEW_FOLDER: this.defaultTitle = this.i18n.get('file.new_folder', 'New Folder');
                break;
                case FileAction.RENAME_FILE: this.defaultTitle = this.i18n.get('file.rename_file', 'Rename File');
                break;
                case FileAction.RENAME_FOLDER: this.defaultTitle = this.i18n.get('file.rename_folder', 'Rename Folder');
                break;
                case FileAction.DELETE_FOLDER: this.defaultTitle = this.i18n.get('file.delete_file', 'Delete File');
                break;
                case FileAction.DELETE_FOLDER: this.defaultTitle = this.i18n.get('file.delete_folder', 'Delete Folder');
                break;
            }
        }
    }

    close() {
        this.dialogRef.close();
    }

    delete() {
        this.dialogRef.close('__DELETE__');
    }

    save() {
        // this.dialogRef.close(this.data.path + '/' + this.input.nativeElement.value);
        this.dialogRef.close(this.input.nativeElement.value);
    }

}